/**
 * GPU Rental Marketplace — shared tier -> SOL price constants (frontend
 * mirror). Display/formatting only — the backend
 * (partyserver/src/utils/rentalPricing.ts) is the source of truth actually
 * enforced at node-registration time. Keep these numbers in sync.
 *
 * All amounts are LAMPORTS (native SOL, 9 decimals; 1 SOL = 1e9 lamports).
 */

import type { GpuTier } from './gpuNetwork';

export const SECONDS_PER_HOUR = 3600;

export const RENT_PRICE_PER_HOUR_LAMPORTS: Record<GpuTier, number> = {
  low: 10_000_000, // 0.01 SOL/hr
  mid: 20_000_000, // 0.02 SOL/hr
  high: 40_000_000, // 0.04 SOL/hr
  datacenter: 80_000_000, // 0.08 SOL/hr
};

export function rentPricePerHourForTier(tier: string | undefined | null): number {
  return RENT_PRICE_PER_HOUR_LAMPORTS[(tier as GpuTier) ?? 'low'] ?? RENT_PRICE_PER_HOUR_LAMPORTS.low;
}

export function rentPricePerSecForTier(tier: string | undefined | null): number {
  return Math.round(rentPricePerHourForTier(tier) / SECONDS_PER_HOUR);
}
